import React from "react";
import { SectionTheme } from "./sections";

type Option<TValue extends number> = {
  readonly label: string;
  readonly value: TValue;
};

type QuestionCardProps<TValue extends number> = {
  readonly theme: SectionTheme;
  readonly question: string;
  readonly options: readonly Option<TValue>[];
  readonly value: TValue | undefined;
  readonly onSelect: (value: TValue) => void;
};

export default function QuestionCard<TValue extends number>({
  theme,
  question,
  options,
  value,
  onSelect
}: QuestionCardProps<TValue>) {
  return (
    <div className="screener-card screener-question">
      <div className="screener-question__text">{question}</div>
      <div className={`screener-options screener-options--${options.length}`} role="radiogroup" aria-label={question}>
        {options.map(option => {
          const selected = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`screener-option screener-option--${theme}${selected ? " screener-option--selected" : ""}`}
              onClick={() => onSelect(option.value)}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
